import SendReceiptMultistep from './sendReceiptMultistep';

export default SendReceiptMultistep;
